export default __webpack_public_path__ + "static/Landmark-Inline-8fcc664df3e7a5c525c022260d4aa037.woff";